const createEFTIndividualStyle = {
	
};

export default createEFTIndividualStyle;
